import {
  ANDROID_PACKAGE,
  ANDROID_STORE_LINK,
  IOS_STORE_LINK,
} from "../constants/chat";

export function getRouteIdentifier(
  mode: "chatNumber" | "publicId",
  chatNumber?: string,
  publicId?: string,
): string | undefined {
  if (mode === "chatNumber") return chatNumber;
  if (mode === "publicId") return publicId;

  return undefined;
}

export function isIOSDevice(userAgent: string): boolean {
  return /iPhone|iPad|iPod/i.test(userAgent);
}

export function isAndroidDevice(userAgent: string): boolean {
  return /Android/i.test(userAgent);
}

export function getStoreLink(userAgent: string): string {
  return isIOSDevice(userAgent) ? IOS_STORE_LINK : ANDROID_STORE_LINK;
}

export function buildImportUserDeepLink(
  requestToken: string,
  connectValue: string,
  mode: "chatNumber" | "publicId",
): string {
  return `idless://importuser?${buildImportUserQuery(
    requestToken,
    connectValue,
    mode,
  )}`;
}

function buildImportUserQuery(
  requestToken: string,
  connectValue: string,
  mode: "chatNumber" | "publicId",
): string {
  const connectParam = mode === "publicId" ? "publicId" : "chatNumber";

  return `token=${requestToken}&${connectParam}=${encodeURIComponent(
    connectValue,
  )}`;
}

// iOS only opens the app for a universal link on a different host than the
// current page, so always point at the other idless.org host.
export function buildImportUserUniversalLink(
  requestToken: string,
  connectValue: string,
  mode: "chatNumber" | "publicId",
): string {
  const host =
    window.location.hostname === "idless.org" ? "www.idless.org" : "idless.org";

  return `https://${host}/importuser?${buildImportUserQuery(
    requestToken,
    connectValue,
    mode,
  )}`;
}

// Chrome opens the app if installed, otherwise the app's Play Store page.
export function buildImportUserIntentLink(
  requestToken: string,
  connectValue: string,
  mode: "chatNumber" | "publicId",
): string {
  return `intent://importuser?${buildImportUserQuery(
    requestToken,
    connectValue,
    mode,
  )}#Intent;scheme=idless;package=${ANDROID_PACKAGE};end`;
}
